/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Spa Manager treatment group
 */
export const SpaProductTreatmentGroupDTO = {
    S_BS: 'S_BS',
    S_BT: 'S_BT',
    S_EV: 'S_EV',
    S_EX: 'S_EX',
    S_HS: 'S_HS',
    S_KI: 'S_KI',
    S_MP: 'S_MP',
    S_SP: 'S_SP',
    S_WB: 'S_WB',
    S_WS: 'S_WS',
    S_WH: 'S_WH'
} as const;
export type SpaProductTreatmentGroupDTO = typeof SpaProductTreatmentGroupDTO[keyof typeof SpaProductTreatmentGroupDTO];

